import { MutableRefObject } from 'react';

export const combineRefs = <T>(
  element: T | null,
  refs: (null | MutableRefObject<T | null> | ((instance: T | null) => void))[],
) =>
  refs.forEach(ref => {
    if (!ref) {
      return;
    }

    if (typeof ref === 'function') {
      ref(element);
    } else {
      ref.current = element;
    }
  });
